import Joi from '@hapi/joi'

export const GoodsTransferDetailsschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("OperationEntity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `OperationEntity required`
    }),
    divisionID: Joi.number().invalid(0).required().label("CollectionPoint").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),




}

